<template>
  <div class="device-managment-pc">
    <div class="management-title">
      <div class="left">
        <span>{{$tc('title', 0)}} {{user.max_device_count}} {{user.max_device_count > 1 ? $tc('title', 2) : $tc('title', 1)}}</span>
        <div class="new-tips">*{{$t('new_tips')}}</div>
      </div>
      <router-link tag="span" to="/dashboard" class="add-device-num">{{$t('add_device')}}</router-link>
    </div>
    <div class="no-record" v-show="hasFetch && records.length === 0">{{$t('no_data')}}</div>

    <div id="list-box" v-if="records.length > 0">
      <div class="records" v-for="(item, index) in records" :key="item.id">
        <div class="platform">
          <img :src="'/static/img/dashboard/ic_'+item.device_platform+'.svg'">
          <span class="text-wrapper">{{$t('device')}} {{index + 1}}{{currentLang === 'en' ? ': ' : '：'}}{{item.name}}</span>
        </div>
        <div class="delete">
          <span @click="$emit('showModifyModal', item.id, item.name)" class="modify-btn"></span>
          <span @click="$emit('showDeleteModal', item.id)" class="delete-btn">{{$t('delete_btn')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import locales from './lang'

  export default {
    name: 'device-management-pc',
    props: ['initData', 'hasFetch'],
    locales,
    data() {
      return {
        records: []
      }
    },
    computed: {
      ...mapState({
        user: 'user',
        currentLang: 'currentLang'
      })
    },
    watch: {
      initData() {
        this.records = this.initData.body.data
        console.log(this.records)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .device-managment-pc {
    border: 1px solid #E0D7E3;
    border-radius: .08rem;
    .management-title {
      line-height: .2rem;
      padding: 0.18rem .16rem;
      border-bottom: 1px solid #E0D7E3;
      font-size: .14rem;
      color: #111;
      letter-spacing: 0;
      border-radius: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .new-tips {
        margin-top: 8px;
        font-size: 12px;
        line-height: 16px;
        color: #666;
      }

      .add-device-num {
        width: 180px;
        height: 40px;
        line-height: 40px;
        border: 1px solid rgba(65,108,248,1);
        border-radius: 20px;
        font-size: 16px;
        font-weight: 600;
        color: #416CF8;
        letter-spacing: 0.8px;
        text-align: center;
        cursor: pointer;
      }
    }

    .no-record {
      margin: 0.8rem auto 1.8rem;
      text-align: center;
      color: #666;
    }

    #list-box {
      min-height: 6.08rem;
    }
    .records {
      border-bottom: .01rem solid #E0D7E3;
      font-size: 0;
      padding: .16rem .16rem .16rem .4rem;
      div {
        text-align: center;
        display: inline-block;
        font-size: .14rem;
        letter-spacing: 0;
        color: #666;
        &.platform {
          width: 50%;
          text-align: left;
          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
          }
          .text-wrapper {
            white-space: pre-wrap;
          }
        }
        &.delete {
          width: 50%;
          color: #F76B4C;
          text-align: right;
          span.delete-btn {
            cursor: pointer;
            display: inline-block;
            width: 104px;
            height: 26px;
            line-height: 26px;
            letter-spacing: 0;
            text-align: center;
            border: 1px solid #F76B4C;
            border-radius: 13px;
          }
          span.modify-btn {
            cursor: pointer;
            width: 20px;
            height: 20px;
            margin-right: 40px;
            display: inline-block;
            vertical-align: middle;
            background: url('/static/img/dashboard/ic_modify.svg') no-repeat;
          }
        }
      }
    }
  }

  .spinner-component-box {
    min-height: .6rem;
    margin: .1rem 0;
  }
</style>



// WEBPACK FOOTER //
// DeviceManagementPC.vue?31ee8d6b